<template>
    <img src="/images/promo/hero-section/telephone.png"
     alt="Telephone" />
</template>

<script>
export default {};
</script>
